export let FullNameFormatterType = /*#__PURE__*/function (FullNameFormatterType) {
  FullNameFormatterType["FIRST_NAME_ONLY"] = "FIRST_NAME_ONLY";
  FullNameFormatterType["LAST_NAME_ONLY"] = "LAST_NAME_ONLY";
  FullNameFormatterType["FIRST_NAME_AND_LAST_NAME"] = "FIRST_NAME_AND_LAST_NAME";
  return FullNameFormatterType;
}({});
export let FulfillmentMethodType = /*#__PURE__*/function (FulfillmentMethodType) {
  FulfillmentMethodType[FulfillmentMethodType["PICKUP"] = 0] = "PICKUP";
  FulfillmentMethodType[FulfillmentMethodType["DELIVERY"] = 1] = "DELIVERY";
  FulfillmentMethodType[FulfillmentMethodType["NONE"] = 2] = "NONE";
  return FulfillmentMethodType;
}({});
//# sourceMappingURL=order.js.map